export const createCardSlice = (set, get) => ({
  card: {
    data: null,
  },
  cardActions: {
    setCardData: (cardData) =>
      set((state) => {
        state.card.data = cardData;
      })
  },
});